__turbopack_context__.v({
  "action": "public-watch-cta-module__F2_0eW__action",
  "actions": "public-watch-cta-module__F2_0eW__actions",
  "artwork": "public-watch-cta-module__F2_0eW__artwork",
  "body": "public-watch-cta-module__F2_0eW__body",
  "copy": "public-watch-cta-module__F2_0eW__copy",
  "fallback": "public-watch-cta-module__F2_0eW__fallback",
  "grain": "public-watch-cta-module__F2_0eW__grain",
  "heading": "public-watch-cta-module__F2_0eW__heading",
  "helper": "public-watch-cta-module__F2_0eW__helper",
  "illustration": "public-watch-cta-module__F2_0eW__illustration",
  "section": "public-watch-cta-module__F2_0eW__section",
  "shader": "public-watch-cta-module__F2_0eW__shader",
  "sheet": "public-watch-cta-module__F2_0eW__sheet",
});
